import { observable, action, makeObservable, computed } from "mobx";
import SearchStore from "stores/SearchStore";

class SalesStore {
  constructor() {
    makeObservable(this);
  }

  /**
   * 매출조회 내역 페이징 객체
   * @type {{sales_page_no: number, sales_max_page: number}}
   * @private
   */
  @observable
  _st_sales_paging = {
    sales_page_no: 1,
    sales_max_page: 1,
  };

  @computed
  get getSalesPaging() {
    return this._st_sales_paging;
  }

  /**
   * 매출조회 내역  페이징 객체 값 셋팅
   * @param key
   * @param value
   */
  @action
  setSalesPagingInfo(key, value) {
    this._st_sales_paging = { ...this._st_sales_paging, [key]: value };
  }

  /**
   * 누락상품조회 내역 페이징 객체
   * @type {{sales_page_no: number, sales_max_page: number}}
   * @private
   */
  @observable
  _st_sales_etc_paging = {
    sales_page_no: 1,
    sales_max_page: 1,
  };

  @computed
  get getSalesEtcPaging() {
    return this._st_sales_etc_paging;
  }

  /**
   * 누락상품조회  페이징 객체 값 셋팅
   * @param key
   * @param value
   */
  @action
  setSalesEtcPagingInfo(key, value) {
    this._st_sales_etc_paging = { ...this._st_sales_etc_paging, [key]: value };
  }

  /**
   * 매출조회 내역  다음페이지 이동
   */
  @action
  nextSalesPage() {
    const max_page = this._st_sales_paging.sales_max_page;
    let page_no = this._st_sales_paging.sales_page_no;

    if (page_no < max_page) {
      this._st_sales_paging.sales_page_no = page_no + 1;
    }
  }

  /**
   * 매출조회 내역 이전페이징 이동
   */
  @action
  prevSalesPage() {
    let page_no = this._st_sales_paging.sales_page_no;
    if (page_no > 1) {
      this._st_sales_paging.sales_page_no = page_no - 1;
    }
  }

  /**
   * 누락상품조회 내역  다음페이지 이동
   */
  @action
  nextSalesEtcPage() {
    const max_page = this._st_sales_etc_paging.sales_max_page;
    let page_no = this._st_sales_etc_paging.sales_page_no;

    if (page_no < max_page) {
      this._st_sales_etc_paging.sales_page_no = page_no + 1;
    }
  }

  /**
   * 누락상품조회 내역 이전페이징 이동
   */
  @action
  prevSalesEtcPage() {
    let page_no = this._st_sales_etc_paging.sales_page_no;
    if (page_no > 1) {
      this._st_sales_etc_paging.sales_page_no = page_no - 1;
    }
  }

  /**
   * 매출조회 내역 레이어 열고 닫기
   * @type {{detail_area_view: boolean, key_area_view: boolean}}
   * @private
   */
  @observable
  _st_sales_search_view = {
    key_area_view: false,
    detail_area_view: false,
  };

  @computed
  get getSalesSearchView() {
    return this._st_sales_search_view;
  }

  @action
  setSalesSearchView(key, value) {
    this._st_sales_search_view = { ...this._st_sales_search_view, [key]: value };
  }

  @action
  initSalesSearchView() {
    this._st_sales_search_view = {
      key_area_view: false,
      detail_area_view: false,
    };
  }

  /**
   * 검색 키값
   * @type {string}
   * @private
   */
  @observable
  _st_sales_search_key_val = {
    key: "mobileOrderNo",
    val: "오늘",
  };

  @computed
  get getSalesSearchKeyVal() {
    return this._st_sales_search_key_val;
  }

  @action
  setSalesSearchKeyVal(key, val) {
    this._st_sales_search_key_val = { key: key, val: val };
  }

  @action
  initSearchKeyVal(key, val) {
    this._st_sales_search_key_val = {
      key: "mobileOrderNo",
      val: "오늘",
    };
  }

  //채널리스트 페이징 처리
  @observable
  _st_channel_page_cnt = 1;

  @computed
  get getChannelPageCnt() {
    return this._st_channel_page_cnt;
  }

  @action
  setChannelPageCnt(cnt) {
    this._st_channel_page_cnt = cnt;
  }

  /**
   * 상세검색 버튼
   * @type {{delivery: boolean, niceorder: boolean, coupang: boolean, yogiyo: boolean, pickup: boolean, naver: boolean, baemin: boolean, order_s: boolean, morder: boolean, paid: boolean, paid_cash: boolean, order_e: boolean, paid_card: boolean, table: boolean, wemakeo: boolean}}
   * @private
   */
  @observable
  _st_detail_button_view = {
    item: {
      all: true,
      baemin: false,
      baemin1: false,
      yogiyo: false,
      yogiyoexpress: false,
      eats: false,
      wmpo: false,
      specialdelivery: false,
      mukkebi: false,
      ddangyo: false,
      ddangbaedal: false,
      daeguro: false,
      incheoneum: false,
      naver: false,
      baedalys: false,
      panda: false,
      pandaself: false,
      baeminstore: false,
      bmsmile: false,
      gamsungcoffee: false,
      hasamdongcoffee: false,
      routinecoffee: false,
      talkpick: false,
      demonstration: false,
      naverBooking: false,
      naverConnect: false,
      baegeokcoffee: false,
      baroder: false,
      etc: false,
    },
    channelList: {
      0: [
        "all",
        "baemin",
        "baemin1",
        "yogiyo",
        "yogiyoexpress",
        "eats",
        "wmpo",
        "mukkebi",
        "ddangyo",
        "ddangbaedal",
        "naver",
        "naverConnect",
      ],
      1: [
        "specialdelivery",
        "daeguro",
        "incheoneum",
        "baedalys",
        "panda",
        "pandaself",
        "baeminstore",
        "bmsmile",
        "gamsungcoffee",
        "baegeokcoffee",
        "talkpick",
        "routinecoffee",
      ],
      2: [
        "demonstration",
        "baroder",
        "hasamdongcoffee",
        "etc",
      ],
    },
    beforeItem: {
      all: true,
      baemin: false,
      baemin1: false,
      yogiyo: false,
      yogiyoexpress: false,
      eats: false,
      wmpo: false,
      specialdelivery: false,
      mukkebi: false,
      ddangyo: false,
      ddangbaedal: false,
      daeguro: false,
      incheoneum: false,
      naver: false,
      baedalys: false,
      panda: false,
      pandaself: false,
      baeminstore: false,
      bmsmile: false,
      gamsungcoffee: false,
      hasamdongcoffee: false,
      baegeokcoffee: false,
      talkpick: false,
      routinecoffee: false,
      demonstration: false,
      naverBooking: false,
      naverConnect: false,
      baroder: false,
      etc: false,
    },
  };

  @computed
  get getDetailButtonView() {
    return this._st_detail_button_view.item;
  }

  @computed
  get getOrderChannelListView() {
    return this._st_detail_button_view.channelList;
  }

  @action
  setDetailButtonView(key, value) {
    const newItem = { ...this._st_detail_button_view.item, [key]: value };

    // 네이버 채널 선택 시 naver와 naverBooking 함께 처리
    if (key === "naver") {
      newItem.naver = value;
      newItem.naverBooking = value;
    }

    return (this._st_detail_button_view.item = newItem);
  }

  @action
  setBeforeDetailUpdate() {
    this._st_detail_button_view.item = this._st_detail_button_view.beforeItem;
  }
  @action
  setAfterDetailUpdate() {
    this._st_detail_button_view.beforeItem = this._st_detail_button_view.item;
  }

  @action
  initDetailButtonView() {
    this._st_detail_button_view.item = {
      all: true,
      baemin: false,
      baemin1: false,
      yogiyo: false,
      yogiyoexpress: false,
      eats: false,
      wmpo: false,
      specialdelivery: false,
      mukkebi: false,
      ddangyo: false,
      ddangbaedal: false,
      daeguro: false,
      incheoneum: false,
      baedalys: false,
      panda: false,
      pandaself: false,
      baeminstore: false,
      bmsmile: false,
      routinecoffee: false,
      talkpick: false,
      gamsungcoffee: false,
      hasamdongcoffee: false,
      baegeokcoffee: false,
      demonstration: false,
      naverBooking: false,
      naverConnect: false,
      baroder: false,
      etc: false,
    };
    this._st_detail_button_view.beforeItem = {
      all: true,
      baemin: false,
      baemin1: false,
      yogiyo: false,
      yogiyoexpress: false,
      eats: false,
      wmpo: false,
      specialdelivery: false,
      mukkebi: false,
      ddangyo: false,
      ddangbaedal: false,
      daeguro: false,
      incheoneum: false,
      baedalys: false,
      panda: false,
      pandaself: false,
      baeminstore: false,
      bmsmile: false,
      routinecoffee: false,
      talkpick: false,
      gamsungcoffee: false,
      hasamdongcoffee: false,
      demonstration: false,
      baegeokcoffee: false,
      naverBooking: false,
      naverConnect: false,
      baroder: false,
      etc: false,
    };
  }

  /**
   * 상품명 검색어
   * @type {string}
   * @private
   */
  @observable
  _st_product_name_search_val = "";

  @computed
  get getProductNameSearchVal() {
    return this._st_product_name_search_val;
  }

  @action
  setProductNameSearchVal(val) {
    this._st_product_name_search_val = val;
  }

  /**
   * 상단 날짜 버튼 관리
   * @type {string}
   * @private
   */
  @observable
  _st_sale_date_term = {
    today: true, // 오늘
    yesterday: false, // 어제
    lastmonth: false, // 지난달
    week: false, // 일주전
    month: false, // 이번달
  };

  @computed
  get getSalesDateTerm() {
    return this._st_sale_date_term;
  }

  @action
  setSalesDateTerm(key, value) {
    this._st_sale_date_term = { ...this._st_sale_date_term, [key]: value };
  }

  @action
  initSalesDateTerm() {
    this._st_sale_date_term = {
      today: true, // 오늘
      yesterday: false, // 어제
      week: false, // 일주전
      lastmonth: false, // 지난달
      month: false, // 이번달
    };
  }

  @action
  searchDateTerm() {
    this._st_sale_date_term = {
      today: false, // 오늘
      yesterday: false, // 어제
      week: false, // 일주전
      lastmonth: false, // 지난달
      month: false, // 이번달
    };
  }

  /**
   * 상단 날짜 버튼별 값
   * @type {string}
   * @private
   */
  @observable
  _st_sales_date_term_val = {
    today: new Date(), // 오늘
    yesterday: new Date(), // 어제
    week: new Date(), // 일주일
    lastmonth: new Date(), // 지난달
    month: new Date(), // 이번달1일
  };

  @computed
  get getSalesDateTermVal() {
    return this._st_sales_date_term_val;
  }

  @action
  setSalesDateTermVal(key, value) {
    this._st_sales_date_term_val = { ...this._st_sales_date_term_val, [key]: value };
  }

  /**
   * 상단 날짜 값
   * @type {{end_val: string, start_val: string}}
   * @private
   */
  @observable
  _st_sales_date_val = {
    start_val: new Date(),
    end_val: new Date(),
  };

  @computed
  get getSalesDateVal() {
    return this._st_sales_date_val;
  }

  @action
  setSalesDateVal(key, value) {
    this._st_sales_date_val = { ...this._st_sales_date_val, [key]: value };
  }

  @action
  initSalesDateVal() {
    this._st_sales_date_val = {
      start_val: new Date(),
      end_val: new Date(),
    };
  }

  /**
   * 상품유형
   * @type
   * @private
   */
  @observable
  _st_product_type_val = {
    all: true,
    menu: false,
    option: false,
    productType: "A",
  };

  @computed
  get getProductTypeVal() {
    return this._st_product_type_val;
  }

  @action
  setProductTypeVal(key, value) {
    this._st_product_type_val = { ...this._st_product_type_val, [key]: value };
  }

  @action
  searchProductType() {
    this._st_product_type_val = {
      all: true,
      menu: false,
      option: false,
      productType: "A",
    };
  }

  /**
   * 가격유형
   * @type
   * @private
   */
  @observable
  _st_price_type_val = {
    all: true,
    charge: false,
    free: false,
    productPriceType: "A",
  };

  @computed
  get getPriceTypeVal() {
    return this._st_price_type_val;
  }

  @action
  setPriceTypeVal(key, value) {
    this._st_price_type_val = { ...this._st_price_type_val, [key]: value };
  }

  @action
  searchPriceType() {
    this._st_price_type_val = {
      all: true,
      charge: false,
      free: false,
      productPriceType: "A",
    };
  }

  /**
   * 정렬
   * @type
   * @private
   */
  @observable
  _st_sort_type_val = {
    orderByProductName: {
      status: false,
      viewType: "desc",
    },
    orderBySaleAmount: {
      status: true,
      viewType: "desc",
    },
    orderBySaleVolume: {
      status: false,
      viewType: "desc",
    },
    viewType: "desc",
  };

  @computed
  get getSortTypeVal() {
    return this._st_sort_type_val;
  }

  @action
  setSortTypeVal(key, value) {
    this._st_sort_type_val = { ...this._st_sort_type_val, [key]: value };
  }

  @action
  setSortTypeStatusVal(type, key, value) {
    this._st_sort_type_val[type] = { ...this._st_sort_type_val[type], [key]: value };
  }

  @action
  searchSortTypeVal() {
    this._st_sort_type_val = {
      orderByProductName: {
        status: false,
        viewType: "desc",
      },
      orderBySaleAmount: {
        status: true,
        viewType: "desc",
      },
      orderBySaleVolume: {
        status: false,
        viewType: "desc",
      },
      viewType: "desc",
    };
  }
  /**
   * 총 수량/금액
   * @type
   * @private
   */
  @observable
  _st_total_sales_val = {
    totalSaleAmount: 0,
    totalSaleCount: 0,
  };

  @computed
  get getTotalSalesVal() {
    return this._st_total_sales_val;
  }

  @action
  setTotalSalesVal(key, value) {
    this._st_total_sales_val = { ...this._st_total_sales_val, [key]: value };
  }

  @action
  searchTotalSalesVal() {
    this._st_total_sales_val = {
      totalSaleAmount: 0,
      totalSaleCount: 0,
    };
  }

  /**
   * 주문채널 선택text
   * @type {[]}
   * @private
   */
  @observable
  _st_sales_product_channel = "전체";

  /**
   * 주문채널 선택text
   * @returns {[]}
   */
  @computed
  get getSalesProductChannel() {
    return this._st_sales_product_channel;
  }

  @action
  setSalesProductChannel(txt) {
    this._st_sales_product_channel = txt;
  }

  /**
   * 상품별매출 목록 조회 OBJ LIST
   * @type {[]}
   * @private
   */
  @observable
  _st_sales_product_list = [];

  /**
   * 상품별매출 목록 조회
   * @returns {[]}
   */
  @computed
  get getSalesProductList() {
    return this._st_sales_product_list;
  }

  @action
  setSalesProductList(list) {
    // this._st_sales_product_list = list.map(order => {
    //     return this.endShopMessageUpdate(this.endOrderNoCreate(order))
    // })
    this._st_sales_product_list = list;
  }

  /**
   * 상품별매출 상세 조회 OBJ LIST
   * @type {[]}
   * @private
   */
  @observable
  _st_sales_product_detail = [];

  /**
   * 상품별매출 상세 조회
   * @returns {[]}
   */
  @computed
  get getSalesProductDetail() {
    return this._st_sales_product_detail;
  }

  @action
  setSalesProductDetail(list) {
    this._st_sales_product_detail = list;
  }

  /**
   * 누락상품매출 조회 OBJ LIST
   * @type {[]}
   * @private
   */
  @observable
  _st_sales_product_etc_list = [];

  /**
   * 누락상품매출 리스트 조회
   * @returns {[]}
   */
  @computed
  get getSalesProductEtcList() {
    return this._st_sales_product_etc_list;
  }

  @action
  setSalesProductEtcList(list) {
    this._st_sales_product_etc_list = list;
  }

  /**
   * 엑셀 조회 조건
   * @type {[]}
   * @private
   */
  @observable
  _st_sales_product_excel_list = [];

  /**
   * 엑셀 조회 조건
   * @returns {[]}
   */
  @computed
  get getSalesProductExcelSearchList() {
    return this._st_sales_product_excel_list;
  }

  @action
  setSalesProductExcelSearchList(list) {
    this._st_sales_product_excel_list = list;
  }

  /**
   * 상세보기 객체로 리스트 객체 재설정
   * @param viewObj
   */
  @action
  addListByViewObj(viewObj) {
    this._st_sales_product_list = this._st_sales_product_list.map(order => {
      if (viewObj.mobileOrderNo === order.mobileOrderNo) {
        return viewObj;
      } else {
        return order;
      }
    });
  }

  @action
  initEndOrderList() {
    this._st_sales_product_list = [];
  }

  endShopMessageUpdate(order) {
    if (order.shopMessage != null) {
      let message = order.shopMessage.replace(/`/g, "").substring(order.shopMessage.indexOf("제]")).split("|");
      if (
        order.mobileOrderFg === "08" ||
        order.mobileOrderFg === "22" ||
        order.mobileOrderFg === "25" ||
        order.mobileOrderFg === "26"
      ) {
        if (order.shopMessage) {
          return { ...order, shopMessage: message[0], dlvMessage: message[1] };
        }
      } else {
        return { ...order, shopMessage: message[0] };
      }
    } else {
      return order;
    }
  }

  endOrderNoCreate(order) {
    return getMobileOrderNo(order);
  }

  //test
  /**
   * 매출 캘린더 OBJ LIST
   * @type {[]}
   * @private
   */
  @observable
  _st_sales_calendar_list = [];

  @computed
  get getSalesCalendarList() {
    return this._st_sales_calendar_list;
  }

  @action
  setSalesCalendarList(list) {
    this._st_sales_calendar_list = list;
  }

  @observable
  _st_sale_cal_setting = {
    monList: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
    dayList: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  };

  @computed
  get getSalesCalSetting() {
    return this._st_sale_cal_setting;
  }

  //시간대 매출 총금액/수량
  @observable
  _st_total_sales_time_val = {
    totalSales: 0,
    totalCount: 0,
    maxSales: 0,
  };

  @computed
  get getTotalSalesTimeVal() {
    return this._st_total_sales_time_val;
  }

  @action
  setTotalSalesTimeVal(key, value) {
    this._st_total_sales_time_val = { ...this._st_total_sales_time_val, [key]: value };
  }

  //시간대 매출rank
  @observable
  _st_sales_time_rank = [];

  @computed
  get getSalesTimeRank() {
    return this._st_sales_time_rank;
  }

  @action
  setSalesTimeRank(list) {
    this._st_sales_time_rank = list;
  }

  //시간대 매출list
  @observable
  _st_sales_time_list = [];

  @computed
  get getSalesTimeList() {
    return this._st_sales_time_list;
  }

  @action
  setSalesTimeList(list) {
    this._st_sales_time_list = list;
  }
}

export default new SalesStore();
